import { http } from "../utils/http-common";
import { CompanyPreferences } from "@/types";

export function getCompanyPreferences(): Promise<CompanyPreferences> {
  return http.get(`/companyPreferences`).then((res) => {
    return res.data.data;
  });
}
export function createCompanyPreferences(companyPreferences: CompanyPreferences) {
  return http.post(`/companyPreferences`, companyPreferences).then((res) => {
    return res.data.data;
  });
}
export function editCompanyPreferences(companyPreferences: CompanyPreferences) {
  return http.put(`/companyPreferences/${companyPreferences.id}`, companyPreferences).then((res) => {
    return res.data.data;
  });
}
